export enum ContentField {
    IMAGE_URL = 'imageUrl',
    TITLE = 'title',
    DESCRIPTION = 'description',


}
